<template>
	<div class="mainWrapper direct-purchase">
		<h1>Create Product Transfer</h1>
		<div class="form">
			<div>
				<span class="label">BD CODE</span>
				<div class="addDetails">
					<b-autocomplete
						:data="searchData"
						placeholder="BD Code"
						field="product.bd_code"
						@typing="searchProducts"
						@select="option => (product = option)"
						class="brandAutocomplete"
					>
						<template slot="empty">No results found</template>
					</b-autocomplete>
				</div>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="transfer-date">
			<span class="label">TRANSFER DATE</span>
			<b-datepicker :date-formatter="dateFormatter" v-model="transferDate" icon="calendar-today"> </b-datepicker>
		</div>

		<div class="list">
			<!-- v-if="products.length > 0" -->
			<div class="products-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					FROM
				</div>

				<div>
					TO
				</div>

				<div>
					QUANTITY
				</div>

				<div>
					REMARK
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="products-list">
				<div>
					{{ item.product.bd_code }}
				</div>

				<div>
					{{ item.product.barcode }}
				</div>

				<div>
					{{ item.product.name }}
				</div>

				<div>
					<b-select placeholder="From" v-model="item.from">
						<option v-for="(from, index) in source" :value="from" :key="index">{{ from }}</option>
					</b-select>
				</div>

				<div>
					<b-select placeholder="To" v-model="item.to">
						<option v-for="(to, index) in source" :value="to" :key="index">{{ to }}</option>
					</b-select>
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-on:change="update(index, 'qty', $event.target.value)" />
				</div>

				<div>
					<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" />
				</div>

				<div>
					<button class="remove-button" @click="removeItem(index)">Remove</button>
				</div>
			</div>
		</div>

		<div v-if="products.length > 0" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddDirectPurchase',
	data: function() {
		return {
			bdcodeData: [], // API bdcode data,
			transferDate: null,
			searchData: [], // API Search data
			product: null, // 1 selected product
			products: [], // Selected products
			name: null,
			supplier: null,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			warehouse: null,
			source: ['stock', 'damaged', 'expired', 'tester']
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {},

	mounted: async function() {
		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		await this.getShops()

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.warehouse = apiGetWarehouse.data._id
	},

	methods: {
		removeItem: function(index) {
			this.products.splice(index, 1)
		},

		save: async function() {
			// Make sure transfer date is not blank
			if (!this.transferDate) {
				this.$swal.fire('Error!', 'Transfer Date is required!', 'error')

				return
			}

			// Make sure products quantities are not blank
			for (const product of this.products) {
				if (product.from == null || product.from == '') {
					this.$swal.fire('Error!', product.product.bd_code + ' FROM cannot be blank', 'error')

					return
				}

				if (product.to == null || product.to == '') {
					this.$swal.fire('Error!', product.product.bd_code + ' TO cannot be blank', 'error')

					return
				}

				if (product.from == product.to) {
					this.$swal.fire('Error!', product.product.bd_code + ' FROM and TO cannot be same', 'error')

					return
				}

				if (product.qty == null || product.qty == '') {
					this.$swal.fire('Error!', product.product.bd_code + ' quantity cannot be blank', 'error')

					return
				}
			}

			let data = {
				warehouse: this.warehouse,
				transfer_date: this.$moment(this.transferDate).format('DD/MM/YYYY'),
				product: []
			}

			this.products.map(product => {
				var productData = {}

				productData.product = product.product._id
				productData.from = product.from
				productData.to = product.to
				productData.stock = product.qty
				if (product.remark) {
					productData.remark = product.remark
				}

				data.product.push(productData)
			})

			const apiSave = await this.$api.saveStockTransfer({ data })

			if (apiSave) {
				this.$swal.fire(apiSave.data.code)

				this.$router.push('/warehouse/stock-transfer')
			} else {
				this.$swal.fire('Error!', 'Something is wrong!', 'error')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			this.product.received_date = null
			this.product.from = null
			this.product.to = null
			this.product.qty = null
			this.product.remark = null

			const duplicate = this.products.filter(product => {
				return product._id == this.product._id
			})

			if (duplicate.length > 0) {
				this.$swal.fire('Duplicate!', this.product.bd_code + ' is already added!', 'error')

				return
			}

			this.products.push(this.product)

			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}
		},

		// Autocomplete search
		searchProducts: async function(name) {
			if (name.length > 1) {
				const data = {
					products: {
						bd_code: name
					},
					populate: ['product']
				}

				const apiSearchProduct = await this.$api.getProducts({ data })

				this.searchData = apiSearchProduct.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
.form {
	width: 500px;
	text-align: left;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-gap: 20px;
	width: 100%;
	margin-bottom: 40px;
}

.transfer-date {
	width: 300px;
	margin-bottom: 2em;
}

span.label {
	font-size: 12px;
	font-weight: bold;
	color: #ccc;
	text-align: left;
	margin-bottom: 10px;
}

/* .products-list {
	margin-bottom: 20px;
	display: grid;

	grid-gap: 20px;
	width: 100%;
	text-align: left;
	font-weight: bold;
} */

.products-list {
	margin: auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	padding: 20px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.header {
	color: #aaa;
	font-weight: bold;
	font-size: 14px;
	margin-bottom: 10px;
}

.remove-button {
	background-color: red;
	color: #fff;
	padding: 5px;
	border: 1px solid red;
}

.qtyInput {
	width: 90px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
	/* background: #70a15a; */
}

.priceInput {
	width: 150px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
}

.remark {
	width: 100%;
	height: 50px;
	border-radius: 4px;
	border: 1px solid #ccc;
	background-color: #fff;
	padding: 5px;
	color: #000;
	font-size: 14px;
	overflow-wrap: break-word;
}
</style>
